import ModalHeader from '@/src/components/Modal/ModalHeader';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import ConditionalFragment from '@/components/common/ConditionalFragment';
import FunwooAPI, {
  Agent,
  SendEmailBuyMailDto,
  SendEmailContactMailDto,
  SendEmailSellMailDto,
  SendEmailSpecificAgentMailDto,
} from '@/swagger';
import { isNotEmptyString, isSet } from '@/utils/formatChecker';

interface CallMeBackFormProps {
  closeBtnPress: () => void;
  agent?: Agent;
  needAddress?: boolean;
  listingId?: string;
}

const CallMeBackForm: FC<CallMeBackFormProps> = ({ closeBtnPress, agent, needAddress = true, listingId }) => {
  const {
    register,
    handleSubmit,
    formState: { isDirty, isValid, isSubmitting },
  } = useForm({ mode: 'onChange' });

  const onSubmit = ({ name, phone, address = '' }: { name: string; phone: string; address: string }) => {
    (async () => {
      try {
        let data: SendEmailBuyMailDto | SendEmailContactMailDto | SendEmailSellMailDto | SendEmailSpecificAgentMailDto;

        if (isNotEmptyString(address)) {
          data = {
            type: 'SELL',
            address,
            name,
            phone,
          } as SendEmailSellMailDto;
        } else if (isSet(agent)) {
          data = {
            type: 'SPECIFIC_AGENT',
            agent_id: agent.id,
            name,
            phone,
          } as SendEmailSpecificAgentMailDto;
        } else if (isSet(listingId)) {
          data = {
            type: 'BUY',
            name,
            phone,
            listing_id: listingId!,
          } as SendEmailBuyMailDto;
        } else {
          data = {
            type: 'CONTACT',
            name,
            phone,
          } as SendEmailContactMailDto;
        }

        await FunwooAPI.mailApi.sendEmail(data);
        toast.info('已送出，我們會儘速與你聯絡');
        closeBtnPress();
      } catch (error) {}
    })();
  };
  return (
    <div className={'flex w-100 md:1/3 bg-white flex-col'}>
      <ModalHeader closeBtnPress={closeBtnPress} title={'回電給我'} />
      <form onSubmit={handleSubmit(onSubmit)} className={'flex mx-6 flex-col'}>
        <p className='text-sm leading-normal text-gray700 my-6'>
          請留下你的資訊，{agent?.name || 'FUNWOO'} 會於 24 小時內和你聯絡！
        </p>
        <p className='text-sm leading-normal uppercase text-gray700 mb-1'>稱呼（希望顧問如何稱呼你）</p>
        <input
          {...register('name', { required: true, maxLength: 20 })}
          type='text'
          className={'h-2xl w-full border border-gray300 p-2'}
        />
        <p className='text-sm leading-normal uppercase text-gray700 mb-1 mt-2'>手機</p>
        <input
          {...register('phone', { required: true, maxLength: 12, pattern: /^09[0-9]{8}$/ })}
          type='tel'
          className={'h-2xl w-full border border-gray300 p-2'}
        />
        <ConditionalFragment condition={needAddress}>
          <p className='text-sm leading-normal uppercase text-gray700 mb-1'>完整物件地址</p>
          <input
            {...register('address', { maxLength: 40 })}
            type='text'
            className={'h-2xl w-full border border-gray300 p-2'}
          />
        </ConditionalFragment>
        <div className={'flex flex-row items-center mt-4 mb-9'}>
          <input {...register('allowRule', { required: true, maxLength: 20 })} className={'mr-2'} type='radio'></input>
          <p className='text-sm leading-normal uppercase text-gray700'>
            我已閱讀 服務條款與隱私權聲明，並同意 FUNWOO 依照該聲明和該策略使用我的相關資訊。
          </p>
        </div>
        <input
          disabled={!isDirty || !isValid || isSubmitting}
          value='送出資料'
          className={`w-full h-3xl ${
            !isDirty || !isValid || isSubmitting ? 'bg-gray500' : 'bg-black'
          }  mb-3 text-white leading-normal text-center tracking-wide font-bold uppercase`}
          type='submit'
        />
      </form>
    </div>
  );
};
export default CallMeBackForm;
